import intermind from '../../../index';

export class TokenResource {
  async createAnonymous(roomId: string, name: string): Promise<string> {
    const { data } = await intermind.httpClient.post<string>('/auth/anonymous', { roomId, name });
    return data;
  }

  async refreshAnonymous(token: string): Promise<string> {
    const { data } = await intermind.httpClient.post<string>(
      '/auth/anonymous/refresh',
      {},
      {
        headers: { Authorization: `Bearer ${token}` }, // Need to manually specify token for routes starting from  /auth
      }
    );
    return data;
  }
}
